<template>
  <div>
    <div class="welcome">
      <div class="logo-container text-center">
        <img class="logo" src="/static/imgs/logo.png" />
        <p class="text-white mb-0 mt-2">
          <small class="text-white">Awesome &amp; Beautiful Initiative</small>
        </p>
      </div>
      <Nav :list="appData.nav"></Nav>
      <!-- <span class="lang">
        <p
          class="yellow-text px-2 pointer lang-active"
          @click="changeLanguage('en', '#eng')"
          id="eng"
        >E N</p>
        <p class="yellow-text px-2 pointer" @click="changeLanguage('fr', '#frn')" id="frn">F R</p>
        <p class="yellow-text px-2 pointer" @click="changeLanguage('sp', '#spn')" id="spn">S P</p>
      </span>-->

      <div class="c-fluid d-sm-n">
        <div class="tag-container" id="welcome">
          <h1 class="tag tag-h1">{{appData.welcome.fullTitle}}</h1>
          <div class="tag">
            <span class="p-3">{{appData.welcome.tag}}</span>
          </div>
        </div>
      </div>
      <div class="tag-container d-lg-n" id="welcome" v-bind:class="{'d-none': showMobileMenu}">
        <h1 class="tag tag-sm-title">{{appData.welcome.fullTitle}}</h1>
        <div class="tag">
          <span class="p-3">{{appData.welcome.tag}}</span>
        </div>
      </div>

      <!-- <svgicon
        icon="menu"
        class="nav-icon d-lg-n pointer"
        @click="showMobileMenu = true"
        v-bind:class="{'d-none': showMobileMenu}"
      ></svgicon>-->
      <img
        class="nav-icon d-lg-n pointer"
        src="/static/imgs/menu.png"
        @click="showMobileMenu = true"
        v-bind:class="{'d-none': showMobileMenu}"
      />

      <div v-bind:class="{'d-none': !showMobileMenu, 'mobile-menu': showMobileMenu}">
        <svgicon icon="logo" color="#ffc001" class="logo pointer" @click="scrollToPosition('')"></svgicon>
        <div class="mobile-nav-wrapper">
          <div class="mobile-nav-container">
            <p
              v-for="(n, index) in appData.nav"
              :key="index"
              class="pointer"
              @click="scrollToPosition('#' + n.viewId);"
            >{{n.name}}</p>
            <button class="n-btn" @click="scrollToPosition('#action')">T A K E &nbsp; A C T I O N</button>
          </div>
        </div>
        <!-- <svgicon icon="cancel" class="nav-icon d-lg-n pointer" @click="showMobileMenu = false"></svgicon> -->
        <img
          class="nav-icon d-lg-n pointer"
          src="/static/imgs/cancel.png"
          @click="showMobileMenu = false"
        />
      </div>
    </div>
    <Mission :list="appData.mission"></Mission>
    <About :body="appData.about"></About>
    <Impact></Impact>
    <Activity></Activity>
    <Facts></Facts>
    <div class="container py-3">
      <ul class="juicer-feed" data-feed-id="youareawesomenbeautiful">
        <h1 class="referral">
          <a href="https://www.juicer.io">Powered by Juicer</a>
        </h1>
      </ul>
    </div>
    <Contribute></Contribute>
    <Team></Team>
    <Contact></Contact>
  </div>
</template>

<script>
import Mission from "./Mission";
import Impact from "./Impact";
import Activity from "./Activity";
import Contribute from "./Contribute";
import Facts from "./Facts";
import Team from "./Team";
import Contact from "./Contact";
import Nav from "./Nav";
import About from "./About";

import "./../compiled-icons/menu";
import "./../compiled-icons/cancel";
import data from "./../data/data";
// import dataFrench from "./../data/data-fr";
// import dataSpanish from "./../data/data-sp";

export default {
  name: "Index",
  components: {
    Mission,
    Impact,
    Activity,
    Contribute,
    Facts,
    Team,
    Contact,
    Nav,
    About
  },
  data() {
    return {
      appData: data,
      showMobileMenu: false
    };
  },
  methods: {
    changeLanguage(lang, id) {
      if (lang == "fr") {
        this.appData = dataFrench;
      } else if (lang == "sp") {
        this.appData = dataSpanish;
      } else {
        this.appData = data;
      }
      $(".lang p").removeClass("lang-active");
      $(id).addClass("lang-active");
    },
    scrollToPosition(viewId) {
      this.showMobileMenu = false;
      let extra = 50;
      if (!viewId) {
        viewId = "#app";
        extra = 0;
      }
      $("html, body").animate(
        {
          scrollTop: $(viewId).offset().top + extra
        },
        0
      );
    }
  }
};
</script>

<style scoped>
.welcome {
  background-image: url("/static/imgs/home.png");
  height: 100vh;
  background-size: cover;
}

@media screen and (min-width: 921px) {
  .tag-container {
    padding: 12rem 0;
  }
}

@media screen and (min-width: 321px) and (max-width: 920px) {
  .tag-container {
    padding: 10rem 2rem;
  }
}

@media screen and (max-width: 320px) {
  .tag-container {
    padding: 7rem 2rem;
  }
}

.tag {
  color: #ffc001;
}
.tag-h1 {
  font-size: 7rem;
  font-weight: 700;
}

@media screen and (max-width: 1139px) {
  .tag-h1 {
    font-size: 6.8rem !important;
  }
}
.tag span {
  max-width: 350px;
  display: block;
  font-size: 1.2rem;
  background-color: #1d1d1d94;
}
.tag-sm-title {
  font-size: 4rem;
  font-weight: 700;
}
.logo-container {
  position: absolute;
  left: 30px;
  top: 40px;
}

@media screen and (max-width: 700px) {
  .logo {
    width: 40px;
  }
}
@media screen and (min-width: 701px) {
  .logo {
    width: 70px;
  }
}
.lang {
  position: absolute;
  right: 50px;
  top: 40px;
  font-size: 0.7rem;
  font-weight: 600;
}
.lang-active {
  border-right: 1px solid white;
}

.nav-icon {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 100;
  width: 70px;
}
@media screen and (min-width: 921px) {
  .d-lg-n {
    display: none;
  }
}

@media screen and (max-width: 920px) {
  .d-sm-n {
    display: none;
  }
}

.mobile-menu {
  background-color: white;
  width: 100%;
  position: fixed;
  bottom: 0;
  top: 0;
  z-index: 200;
  overflow-y: auto;
}
.mobile-nav-wrapper {
  display: table;
  height: 100%;
  text-align: center;
  width: 100%;
}

.mobile-nav-container {
  display: table-cell;
  vertical-align: middle;
}
@media screen and (min-width: 321px) {
  .mobile-nav-container p {
    margin: 4rem 0;
  }
}

@media screen and (max-width: 320px) {
  .mobile-nav-container p {
    margin: 2.5rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue